import { Alert, AlertEvent, AlertInstance, AlertParameterValue } from "ng/src/app/alerts/shared/alert.model";
import { Utils } from "ng/src/app/core/utils";

export interface AlertInstanceTableModel {
	alertId: number,
	alert: Alert,
	entries: AlertInstanceTableEntry[],
	alignmentMap: Record<number | string, boolean>,
	hasInitializedStatuses: boolean
}

export interface AlertInstanceTableEntry {
	event: AlertEvent,
	instance: AlertInstance,
	values: AlertInstanceTableEntryValue[]
}

export interface AlertInstanceTableEntryValue {
	id: number,
	value: AlertParameterValue,
	sortOrder: number,
	displayValue: any
}

export class AlertInstanceTableModel {
	private static fromEvent(ev: AlertEvent.Projections.Detailed) {
		return { alertId: ev.alert.id, alert: ev.alert, entries: [],
			align: 'right', hasInitializedStatuses: false, alignmentMap: {} }
	}
	
	static fromEvents(events: AlertEvent.Projections.Detailed[]) {
		const map: { [key:string]: AlertInstanceTableModel } = {};
		events.forEach(ev => {
			const entry = map[ev.alert.id] = map[ev.alert.id] ?? AlertInstanceTableModel.fromEvent(ev);
			
			const valMap = ev.alertInstance.parameterValues.reduce((map, pv) => {
				map[pv.parameter.id] = pv;
				entry.hasInitializedStatuses = entry.hasInitializedStatuses || ev.status.id === 5;
				return map;
			}, {} as { [key:number]: AlertParameterValue });
			
			const values = ev.alert.parameters.reduce((arr, p) => {
					const val = valMap[p.id];
					let displayValue: string | number | null = null;
					
					if (val?.tagValue != undefined)
						displayValue = val.tagValue.stringValue;
					else if (val?.numericValue != undefined)
						displayValue = val.numericValue;
					else if (val?.stringValue != undefined)
						displayValue = val.stringValue;
					
					let alignment = entry.alignmentMap[p.id] ?? true;
					entry.alignmentMap[p.id] = alignment && (typeof displayValue === 'number' || displayValue == null);
					
					arr.push({
						id: p.id,
						value: valMap[p.id],
						sortOrder: p.sortOrder,
						displayValue: displayValue
					})
					return arr;
				}, [] as AlertInstanceTableEntryValue[])
				.sort(Utils.createSortFunction(ev => ev.sortOrder))
			
			entry.entries.push({
				event: ev,
				instance: ev.alertInstance,
				values: values
			});
		});
		return map;
	}
}